import React, { Component } from 'react';
import { Container, Card, Image, Button, Message, Statistic } from 'semantic-ui-react';
import moment from 'moment';
import StepGroup from './StepGroup.js';

class FromUserCard extends Component {
  render() {
    let selection;
    if (this.props.status === 'paid') {
      selection = <Card.Content extra>
        <Button positive fluid onClick={this.props.onClickConfirmVerify}>核實</Button>
      </Card.Content>
    }
    return (
      <Card>
        <Card.Content>
          <Image floated='right' size='mini' src={this.props.imageSrc} />
          <Card.Header>{this.props.header}</Card.Header>
          <Card.Meta>{moment(this.props.createDate).format('YYYY-MM-DD')}</Card.Meta>
          <Card.Description>
            <Container textAlign='center'>
              <Message>{this.props.alipayName}</Message>
              <Statistic>
                <Statistic.Value>{this.props.amount}</Statistic.Value>
                <Statistic.Label>{this.props.method}</Statistic.Label>
              </Statistic>
            </Container>
            {selection}
          </Card.Description>
        </Card.Content>
        <Card.Content extra>
          <StepGroup status={this.props.status} />
        </Card.Content>
      </Card>
    )
  }
}

export default FromUserCard;



// WEBPACK FOOTER //
// ./src/FromUserCard.js